import { useUnit } from 'effector-react'
import { Button, MenuItem } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { $portalProfile } from '@/entities/profile/portal'
import { useI18n } from '@/shared/lib/i18n'

import { supportIDClicked } from '../model'

type SupportIDButtonProps =
    | {
          variant: 'navbar'
          className?: never
      }
    | {
          variant: 'dropdown'
          className?: string
      }

export function SupportIDButton({ variant, className }: SupportIDButtonProps) {
    const { i18n } = useI18n()

    const profile = useUnit($portalProfile)

    const handleSupportIDClick = useUnit(supportIDClicked)

    if (!profile) {
        return null
    }

    if (variant === 'dropdown') {
        return (
            <MenuItem className={className} onAction={() => handleSupportIDClick(profile.supportId)}>
                <i className={cx('fa-solid fa-heart', css({ width: '3', color: 'secondary' }))} />
                &nbsp;{i18n.TEXT_YOUR_SUPPORT_ID}
                <span>&nbsp;{profile.supportId}</span>
            </MenuItem>
        )
    }

    return (
        <li
            className={css({
                display: { base: 'none', lg: 'block' },
                color: '[rgba(0, 0, 0, 0.8)]',
                fontSize: '[14px]',
                lineHeight: '[20px]',
                cursor: 'pointer',
            })}
        >
            <Button
                className={css({
                    backgroundColor: 'transparent', // reset button
                    border: 'none', // reset button
                    padding: '0', // reset button
                    borderRadius: 'xs',
                    _hover: { backgroundColor: 'primary/25' },
                    _focus: { backgroundColor: 'primary/25' },
                })}
                onPress={() => handleSupportIDClick(profile.supportId)}
            >
                <i className={cx('fa-solid fa-heart', css({ color: 'secondary' }))} />
                &nbsp;{i18n.TEXT_YOUR_SUPPORT_ID}
                <span>&nbsp;{profile.supportId}</span>
            </Button>
        </li>
    )
}
